<template>
  <Modal title="Автоопределение штрихкода" @backdrop-click="close">
    <template slot="body">
      <div class="modal__barcode">
        <div class="barcode__buttons" v-if="!readerWasRunned">
          <div class="buttons__button">
            <button @click="startScannerDevice" class="btn btn-info">
              <i class="fa fa-barcode"></i>
              Через устройство
            </button>
          </div>
          <div class="buttons__button">
            <button @click="startWebcam" class="btn btn-info">
              <i class="fa fa-video-camera"></i>
              Через вебкамеру
            </button>
          </div>
        </div>
        <div :class="deviceFormCss" class="body__form_device">
          <p class="body__text_scanner-tip">
            Пожалуйста, просканируйте штрихкод устройством - и затем нажмите
            на "Обработать"
          </p>
          <input
            :value="barcodeValue"
            class="form-control"
            @click="$refs.barcodeInput.focus()"
            readonly
          />
          <input ref="barcodeInput" class="form__input_barcode" />
        </div>
        <div v-show="webcamWasEnabled" class="body__form_webcam">
          <div id="reader"></div>
          <p class="barcode__value">
            {{ barcodeValue }}
          </p>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div v-if="selectedMode === 'device' && !detectedBarcode">
          <button
            type="button"
            class="btn btn-success"
            @click="printBarcode"
          >
            Обработать
          </button>
        </div>
        <div>
          <button
            :class="buttonCss"
            class="modal-default-button btn"
            @click="close"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/_shared/components/ui/Modal";
import { useBarcodeScanner, useBarcodeWebcam } from "@/stock/mixins";
export default {
  components: {
    Modal,
  },
  mixins: [useBarcodeScanner, useBarcodeWebcam],
  emits: ["close"],
  data() {
    return {
      detectedBarcode: "",
      readerWasRunned: false,
      selectedMode: "",
    };
  },
  methods: {
    close() {
      this.stopWebcam();
      this.stopScannerDevice();
      this.readerWasRunned = false;

      const receivingBarcode = this.detectedBarcode;
      this.detectedBarcode = "";
      this.$emit("close", receivingBarcode);
    },
  },
  computed: {
    deviceFormCss() {
      return {
        'body__form_hidden': !this.deviceWasEnabled,
      };
    },
    buttonCss() {
      return {
        "btn-danger": this.codeLength === 0,
        "btn-success": this.codeLength > 0,
      };
    },
    buttonText() {
      let text = "Вернуться без штрихкода";
      if (this.codeLength > 0) {
        text = `Сохранить результаты`;
      }
      return text;
    },
    barcodeValue() {
      let text = "Пока ничего не обнаружено";
      if (this.codeLength > 0) {
        text = `Обнаруженный штрихкод: ${this.detectedBarcode}`;
      }
      return text;
    },
    codeLength() {
      return this.detectedBarcode.length;
    },
  },
};
</script>

<style scoped>
.buttons__button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.barcode__buttons {
  display: flex;
  flex-direction: row;
  column-gap: 1em;
  justify-content: center;
  margin: 6em 0;
}

.barcode__value {
  margin: 1.5em 0;
  text-align: center;
  font-weight: 700;
}

.form__input_barcode {
  opacity: 0;
  overflow: hidden;
  height: 0.1px;
  width: 0.1px;
  position: absolute;
}
.body__form_hidden {
  display: none;
}
.body__text_scanner-tip {
  max-width: 300px;
  text-align: center;
}
@media (max-width: 1023px) {
  .body__text_scanner-tip {
    max-width: unset;
  }
}
@media (max-width: 767px) {
  .modal__buttons > div > button {
    width: 100%;
  }
  .barcode__buttons,
  .modal__buttons {
    display: flex;
    flex-direction: column;
  }
  .modal__buttons {
    row-gap: 1em;
    padding: 0 10%;
  }
  .barcode__buttons {
    row-gap: 2em;
  }
}
@media (max-width: 419px) {
  .modal__buttons {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/stock/widgets/barcode/ReaderModal.vue